export const TOKEN_KEY = 'TOKEN_CEMS';
export const REFRESH_TOKEN_KEY = 'REFRESH_TOKEN_CEMS';
export const URL_RETURN_KEY = 'returnUrl';
export const CSRF_TOKEN_KEY = 'CSRF_TOKEN_CEMS';
export const DEVICE_ID_KEY = 'DEVICE_ID';
export const FCM_TOKEN = 'FCM_TOKEN';

